import React from 'react';
import { Grid } from '@abyss/web/ui/Grid';
import { TextInput } from '@abyss/web/ui/TextInput';
import { ApplyTokenController } from './ApplyToken.Controller';
import { Button } from '@abyss/web/ui/Button';
import { FormProvider } from '@abyss/web/ui/FormProvider';

export const ApplyToken: React.FC = () => {
  const controller = ApplyTokenController();

  return (
    <FormProvider state={controller.form}>
      <Grid>
        <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Grid>
            <Grid.Col span={{ xs: 12 }}>
              <TextInput
                label="Base URL"
                model="baseUrl"
                maxLength={5000}
                validators={{
                  required: 'Base URL is required',
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ xs: 12 }}>
              <TextInput
                label="Token"
                model="token"
                maxLength={5000}
                validators={{
                  required: 'Token is required',
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ xs: 12 }}>
              <Button type={ controller.fieldsDisabled ? 'button' : 'submit' } onClick={controller.Action.ApplyClick}>
                { controller.fieldsDisabled ? 'Clear Token' : 'Apply Token' }
              </Button>
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
    </FormProvider>
  );
};
